import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SessionsService } from '../common/services/sessions.service';
import { Router } from '@angular/router';
//import { FooterComponent } from '../footer/footer.component';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import {UtilsService} from '../common/services/utils.service';
import * as $ from 'jquery';
declare var show_okshan_alert: Function;
declare var show_okshan_alert3: Function;
declare var set_horizontal_menu: Function;
declare var stickyHeader: Function;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  sessionLoginStatus:boolean=false;
  sessionId:number=0;
  sessionFirstName:string='';
  sessionLastName:string='';
  sessionProfilePic:string='';
  sessionEmailId:string='';
  sessionMobileNo:string='';
  sessionDealershipName:string='';
  sessionProfileType:number=-1;
  sessionStatus:number=0;
  sessionCityId:number=0;
  sessionStateId:number=0;
  isLoading:boolean=true;
  isOtpConfirmed:boolean=false;
  eventStatusMsg:string='';
  getOtpVisitorBtnStatus:boolean=true;
  getOtpTryCount:number=0;
  counter:number=0;
  counterLabel:string='';
  actionStatus:boolean=false;
  visitorRegTerm:boolean=false;
  public onlineOffline: boolean = navigator.onLine;

  page:string="";

  constructor(private sessionsService:SessionsService,private router:Router,private httpserviceService:HttpserviceService,private utilsService:UtilsService) 
  { 
          
  }

  visitorRegFormGroup;
  visitorRegMobile;
  visitorRegMobileOtp;
  visitorRegDealership;
  visitorRegFullName;
  visitorRegLastName;
  visitorRegState;
  visitorRegCity;
  visitorRegEmail; 
  isVisitorRegSubmit:boolean=false;
  requestInProcess:boolean=false;
  otpConfimedLabel:string="Verify otp";
  stateList=[];
  preferredStateList=[];
  otherStateList=[];
  cityList=[{"id":0,"name":"Select state first"}];
  preferredStateIds="";

  @ViewChild('visitorRegBoxCloseBtn') visitorRegBoxCloseBtn: ElementRef;  

  ngOnInit(): void {
     if(!this.onlineOffline)
     {
     show_okshan_alert("Internet is not working");   
     }

//       const interval = setInterval(() => {
//     if (this.sessionsService.getSession('auth_user') != null ) {
//     if (this.sessionsService.getSession('state_list') == null ) {
//     this.getStateList();
//     }
//     if (this.sessionsService.getSession('state_city_list') == null ) {
//     this.getStateCityList();
//     }
//     if (this.sessionsService.getSession('brand_list') == null ) {
//     this.getBrandList();
//     }
//     // if (this.sessionsService.getSession('all_brand_list') == null ) {
//     // this.getAllBrandList();
//     // }
//     // if (this.sessionsService.getSession('all_model_list') == null ) {
//     // this.getAllModelList();
//     // }
//     // if (this.sessionsService.getSession('all_variant_list') == null ) {
//     // this.getAllVariantList(); 
//     // }
//     // if (this.sessionsService.getSession('all_city') == null ) {
//     //   this.getAllCityList();
//     // }
//     // if (this.sessionsService.getSession('all_state') == null ) {
//     //   this.getAllStateList();
//     // }
//     // if (this.sessionsService.getSession('fuel_type') == null || this.sessionsService.getSession('all_fuel_type') == null) {
//     // this.getFuelTypeList();
//     // }
//     if (this.sessionsService.getSession('all_brand_list') == null || this.sessionsService.getSession('all_model_list') == null || 
//     this.sessionsService.getSession('all_variant_list') == null || this.sessionsService.getSession('all_city') == null || 
//     this.sessionsService.getSession('all_state') == null || this.sessionsService.getSession('all_fuel_type') == null)
//     {
//     this.getAllTypeList()
//     }    
//       clearInterval(interval);      
//     }   
//   }, 100);

     setInterval(() => {
     if(navigator.onLine)
     {        
        if(!this.onlineOffline)
        {
        show_okshan_alert("Internet is working");
        this.onlineOffline=navigator.onLine;
        }
     }
     else if(!navigator.onLine)
     {
        if(this.onlineOffline)
        {
        show_okshan_alert("Internet is not working");
        this.onlineOffline=navigator.onLine;
        }
     }   
     }, 200);
     

     if(this.sessionsService.getSession("login_status")!=null)
    {
       this.sessionLoginStatus=this.sessionsService.getSession("login_status");
    } 
    if(this.sessionsService.getSession("id")!=null)
    {
       this.sessionId=this.sessionsService.getSession("id");
    }
    if(this.sessionsService.getSession("first_name")!=null)
    {
       this.sessionFirstName=this.sessionsService.getSession("first_name");
    }  
    if(this.sessionsService.getSession("last_name")!=null)
    {
       this.sessionLastName=this.sessionsService.getSession("last_name");
    }  
    if(this.sessionsService.getSession("profile_pic")!=null)
    {
       this.sessionProfilePic=this.sessionsService.getSession("profile_pic");
    }  
    if(this.sessionsService.getSession("email_id")!=null)
    {
       this.sessionEmailId=this.sessionsService.getSession("email_id");
    }  
    if(this.sessionsService.getSession("mobile_no")!=null)
    {
       this.sessionMobileNo=this.sessionsService.getSession("mobile_no");
    }  
    if(this.sessionsService.getSession("dealership_name")!=null)
    {
       this.sessionDealershipName=this.sessionsService.getSession("dealership_name");
    }  
    if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    if(this.sessionsService.getSession("status")!=null)
    {
       this.sessionStatus=this.sessionsService.getSession("status");
    }
    if(this.sessionsService.getSession("city_id")!=null)
    {
       this.sessionCityId=this.sessionsService.getSession("city_id");
    }
    if(this.sessionsService.getSession("state_id")!=null)
    {
       this.sessionStateId=this.sessionsService.getSession("state_id");
    } 

    if(this.sessionsService.getSession("profile_type")!=null && this.sessionsService.getSession("status")!=null)
    {
       if(this.sessionsService.getSession("profile_type")!=-1 && this.sessionsService.getSession("status")==1)
       {
         this.actionStatus=true;
       }
    }

     this.visitorRegFormGroup = new FormGroup(
      {
        visitorRegMobile: new FormControl('',[Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),Validators.maxLength(10)]),
        visitorRegMobileOtp: new FormControl('',[Validators.required]),
        visitorRegDealership: new FormControl(''),
        visitorRegFullName: new FormControl('',[Validators.required]),
        visitorRegLastName: new FormControl('',[Validators.required]),
        visitorRegState: new FormControl("0",[Validators.required,Validators.min(1)]),
        visitorRegCity: new FormControl("0",[Validators.required,Validators.min(1)]),
        visitorRegEmail: new FormControl('',[Validators.required,Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),        
      }
    )

    
const interval = setInterval(() => {
    if (this.sessionsService.getSession('state_list') != null ) {
       console.log("called...");
       this.stateList=this.sessionsService.getSession("state_list");
       for(let i=0;i<this.stateList.length;i++)
         {
         if(this.stateList[i].preferred==1)
         {
            this.preferredStateList.push(this.stateList[i]);
            this.preferredStateIds=this.preferredStateIds+"^"+this.stateList[i].id+"^";
         }
         else
         {
            this.otherStateList.push(this.stateList[i]);
         }
         }
  clearInterval(interval);      
    }      
  }, 100);
  setTimeout(() => {
    set_horizontal_menu();
  }, 2000);
  setTimeout(() => {
    stickyHeader();
  }, 200);
  this.page = this.router.url.split("/").pop();
  console.log("this.page : "+this.page);  
  }
  
  
 
  public loadScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  } 

  visitor()
  {
     this.router.navigate(['visitor']);
  }

  visitorcContactUs()
  {
     this.router.navigate(['visitor-contactus']);
  }

  home()
  {
     this.router.navigate(['home']);
  }

  sellCar(type)
  {
     if(type==1)
     {
     this.router.navigate(['sell-car'], { queryParams: { type: type } });
     }
     else if(type==2)
     {
     this.router.navigate(['sell-okshan-car'], { queryParams: { type: type } });
     }
  }

  myCars()
  {
     this.router.navigate(['my-cars']);
  }

  myProfile()
  {
     this.router.navigate(['my-profile']);
  }

  myPreference()
  {
     this.router.navigate(['my-preference']);
  }

   myPaymentHistory()
  {
     this.router.navigate(['my-payment-history']);
  }  

  /** fixedPriceCars function used to get fixed price cars */
  fixedPriceCars()
  {
     this.router.navigate(['fixed-price-cars']);
  }

  /** auctionCars function used to get auction cars */
  auctionCars()
  {
     this.router.navigate(['auction-cars']);
  }

  /** howItsWork function used to open how its work page */
  howItsWork()
  {
     this.router.navigate(['how-its-work']);
  }

  /** howItsWork function used to open how its work page */
  myInspection()
  {
     this.router.navigate(['my-inspection']);
  }

  /** logout function used to remove all sessions  */
  logout()
  {
        this.sessionsService.removeSession("login_status");
        this.sessionsService.removeSession("id");
        this.sessionsService.removeSession("first_name");
        this.sessionsService.removeSession("last_name");
        this.sessionsService.removeSession("profile_pic"); 
        this.sessionsService.removeSession("email_id");
        this.sessionsService.removeSession("mobile_no");
        this.sessionsService.removeSession("dealership_name");
        this.sessionsService.removeSession("profile_type");
        this.sessionsService.removeSession("status");
        this.sessionsService.removeSession("city_id");
        this.sessionsService.removeSession("state_id");
         window.location.href="#/visitor";
  }

  resetJoinUsForm()
  {
     //show_okshan_alert("called");
     //let footerComponent=new FooterComponent(null,null,null,null);
     //footerComponent.resetJoinUsForm();
  }

  /**  resetVisitorRegForm function used to reset visitor form */
  resetVisitorRegForm()
  {
     this.visitorRegFormGroup.reset();
     this.visitorRegFormGroup.controls['visitorRegState'].setValue("0");
     this.visitorRegFormGroup.controls['visitorRegCity'].setValue("0");
     this.isVisitorRegSubmit=false;     
     //this.stateList=this.utilsService.StateList;
     //this.stateCityList=this.utilsService.stateCityList;
  }

  /** sendVisitorRegOtpOnMobile function used to send visitor registration otp on mobile*/   
  proceedVisitorRegOtpOnMobile(data)
  { 
     if(this.getOtpTryCount==3)
     {
        this.eventStatusMsg="Get otp has been reached on limit 3. Try after some time";        
        setTimeout(() => {
        this.getOtpTryCount=0;   
        }, 30*60*1000);
        return false;
     }    
     if(!this.visitorRegFormGroup.get('visitorRegMobile').errors){      
     //this.isLoading=false;
     this.eventStatusMsg="Sending otp on mobile";
     this.httpserviceService.sendRegOtpOnMobileNo("+91"+data.visitorRegMobile).
     pipe(retry(0)).
     subscribe((data)=>this.sendVisitorRegOtpOnMobileResponse(data),
     err => {
       this.eventStatusMsg="Something went wrong !"; 
       console.log('Something went wrong', err);
       this.isLoading=true;
    })
     }
  }

 /** sendVisitorRegOtpOnMobileResponse function used to handle response */
  sendVisitorRegOtpOnMobileResponse(response)
  {
    console.log('sendVisitorRegOtpOnMobileResponse '+ response.status);
    if(response.status==="success")  
     {
     //this.isLoading=true; 
     this.getOtpTryCount++;
     this.eventStatusMsg="Otp has been sent";
     this.getOtpVisitorBtnStatus=false;
     setTimeout(() => {
     this.getOtpVisitorBtnStatus=true;   
     }, 120000);
     this.startCountdown(120);
     }
     else
     {
     this.eventStatusMsg=response.reason;
     //this.isLoading=true;
     } 
  }

  /** proceedConfirmRegOtpOnMobile function used to confirm visitor registration otp  */
  proceedConfirmRegOtpOnMobile(data)
  {

     if(!this.visitorRegFormGroup.get('visitorRegMobile').errors && !this.visitorRegFormGroup.get('visitorRegMobileOtp').errors){ 
     //this.isLoading=false;
     this.eventStatusMsg="";
     let result =this.httpserviceService.confirmRegOtpOnMobileNo3("+91"+data.visitorRegMobile,data.visitorRegMobileOtp,"visitor_request").
     pipe(retry(0)).
     subscribe((data)=>this.confirmRegOtpOnMobileResponse(data),
     err => {
       this.eventStatusMsg="Something went wrong !";
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })       
  }
  }

  /** confirmRegOtpOnMobileResponse function used to handle response */
  confirmRegOtpOnMobileResponse(response)
  {
    console.log('confirmRegOtpOnMobileResponse '+ response.status);
    if(response.status==="success")  
     {
     this.isOtpConfirmed=true;   
     this.eventStatusMsg="";
     }
     else if(response.status==="exists")
     {
     let array=response.details;
     if(array.length>0)
     {
      for(let i=0;i<array.length;i++)
      {
        this.sessionsService.setSession("login_status",true);
        this.sessionsService.setSession("id",array[i].id);
        this.sessionsService.setSession("first_name",array[i].first_name);
        this.sessionsService.setSession("last_name",array[i].last_name);
        this.sessionsService.setSession("profile_pic",array[i].profile_pic); 
        this.sessionsService.setSession("email_id",array[i].email_id);
        this.sessionsService.setSession("mobile_no",array[i].mobile_no);
        this.sessionsService.setSession("dealership_name",array[i].dealership_name);
        this.sessionsService.setSession("profile_type",array[i].profile_type);
        this.sessionsService.setSession("status",array[i].status);
        this.sessionsService.setSession("city_id",array[i].city_id);
        this.sessionsService.setSession("state_id",array[i].state_id);        
        window.location.href="#/home";
      } 
     }
     }
     else
     {
     show_okshan_alert(response.reason);
     this.otpConfimedLabel=response.reason;
     this.eventStatusMsg="";
     //this.isLoading=true;
     } 
  }

  /** proceedRegistration function used to proceed registration  */
  proceedRegistration(data)
  { 
     this.isVisitorRegSubmit=true;
     if(this.visitorRegTerm==false)
     {
        show_okshan_alert("I accept the terms & privacy policies");
        return false;
     } 
     //alert(this.visitorRegFormGroup.valid);
     //alert(this.isOtpConfirmed);
    if(this.visitorRegFormGroup.valid && this.isOtpConfirmed)
    { 
    let formData=new FormData();   
    formData.append('first_name',data.visitorRegFullName);
    formData.append('last_name',data.visitorRegLastName);
    formData.append('profile_pic','');
    formData.append('dealership_name',data.visitorRegDealership);
    formData.append('city_id',data.visitorRegCity);
    formData.append('state_id',data.visitorRegState);
    formData.append('pin_code','');  
    formData.append('email_id',data.visitorRegEmail);
    formData.append('mobile_no',"+91"+data.visitorRegMobile);
    formData.append('address','');
    formData.append('latitude','');
    formData.append('longitude','');
    formData.append('trade_entity',"0");    
    formData.append('field1','');
    formData.append('field2','');
    formData.append('field3','');
    formData.append('field4','');
    formData.append('field5','');
    formData.append('field6','');
    formData.append('field7','');
    formData.append('field8','');
    formData.append('kyc_doc_1','');
    formData.append('kyc_doc_2','');
    formData.append('kyc_doc_3','');
    formData.append('kyc_doc_4','');
    formData.append('kyc_doc_5','');
    formData.append('kyc_doc_6','');
    formData.append('kyc_doc_7','');
    formData.append('kyc_doc_8','');
    formData.append('kyc_doc_9','');    
    formData.append('cancelled_cheque','');
    formData.append('preferred_states_sell','');
    formData.append('preferred_states_buy','');
    formData.append('price_range_from',"0");
    formData.append('price_range_to',"0");
    formData.append('car_brands','');
    formData.append('credit_card_holder_name','');
    formData.append('credit_card_number','');
    formData.append('credit_card_expiration','');
    formData.append('debit_holder_name','');
    formData.append('debit_card_number','');
    formData.append('expiration','');
    formData.append('bank_name','');
    formData.append('ifsc_code','');
    formData.append('bank_address','');
    formData.append('bank_account_number','');
    formData.append('profile_type','-1');
    formData.append('status','0');
    formData.append('web_device_token','');
    formData.append('mobile_device_token','');
    formData.append('password','');

    this.isLoading=false;  
    this.requestInProcess=true;   
    let result =this.httpserviceService.registrationRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.registrationResponse(data),
     err => {
       this.requestInProcess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })
    }
  }

  /** registrationResponse function used to handle response */
  registrationResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     {      
     this.resetVisitorRegForm();
     this.visitorRegBoxCloseBtn.nativeElement.click();  
     this.isLoading=true;
     let array=response.details;
     if(array.length>0)
     {
      for(let i=0;i<array.length;i++)
      {
        this.sessionsService.setSession("login_status",true);
        this.sessionsService.setSession("id",array[i].id);
        this.sessionsService.setSession("first_name",array[i].first_name);
        this.sessionsService.setSession("last_name",array[i].last_name);
        this.sessionsService.setSession("profile_pic",array[i].profile_pic); 
        this.sessionsService.setSession("email_id",array[i].email_id);
        this.sessionsService.setSession("mobile_no",array[i].mobile_no);
        this.sessionsService.setSession("dealership_name",array[i].dealership_name);
        this.sessionsService.setSession("profile_type",array[i].profile_type);
        this.sessionsService.setSession("status",array[i].status);
        this.sessionsService.setSession("city_id",array[i].city_id);
        this.sessionsService.setSession("state_id",array[i].state_id);        
        window.location.href="#/home";
      } 
     }
     }
     else
     {
     show_okshan_alert(response.reason);
     this.requestInProcess=false;
     this.isLoading=true;
     } 
  }

  /** startCountdown used to  start count down after otp sent  */
  startCountdown(seconds) {
  this.counter = seconds;
    
  const interval = setInterval(() => {
    if (this.counter == 0 ) {
      clearInterval(interval);
      console.log('Ding!');
    }
    this.counter--; 
    this.counterLabel=Math.floor(this.counter/60)+":"+Math.floor(this.counter%60);   
  }, 1000);
}

/** onChangeState function used to perform event on state change */
  onChangeState(value)
  {
   if(value!=0 && this.preferredStateIds!="" &&  this.preferredStateIds.indexOf("^"+value+"^")<0)
   {
     show_okshan_alert3("We are currently not operational in this state, however you are welcome to submit your details and we will enroll you as soon as possible");
   }  
   let list=this.sessionsService.getSession("state_city_list");  
   this.cityList=list[value];
  } 
   
  onChangeTerm($event) {
  this.visitorRegTerm = $event.target.checked;
  }

}
